import { Alert, Stack, TextField, Typography } from "@mui/material";
import Layout from "../Frames/Layout";
import { useState } from "react";
import { Link, useParams } from "react-router-dom";
import { useEffect } from "react";
import API from "../../services/API";
import Loader from "../Tools/Loader";
import Address from "../Inputs/Address";
import { LoadingButton } from "@mui/lab";
import { useContext } from "react";
import ToastContext from "../../services/Context/ToastContext";

export default function EventPlace(){

    const {setToast} = useContext(ToastContext)

    const {id} = useParams()

    const [course, setCourse] = useState(null)
    const [status, setStatus] = useState('loading')

    useEffect(() => {

        if(id !== 'new'){

            API.get(`/design/courses/${id}`)
                .then(r => {
                    setCourse(r.data)
                    setStatus('ready')
                })
                .catch(_ => setStatus('error'))

        }else{

            setStatus('new')
        }

    }, [id])


    const handleSubmit = e => {
        e.preventDefault();

        setStatus('submit')

        API.put(`/design/courses/${id}`, course)
            .then(r => setToast({
                severity: 'success',
                message: "Vos modifications ont été enregistrées avec succès",
            }))
            .catch(_ => setToast({
                severity: 'error',
                message: "Une erreur s'est produite. Vos modifications n'ont pas pu être enregistrées.",
            }))
            .finally(() => setStatus('ready'))
        
    }


    return <Layout menu='organize' tab='place'>


        <Stack spacing={4} sx={{maxWidth: 600, margin: 'auto', pt: 4, pb: 4}}>


            <Typography variant='h1'>Lieu de l'événement</Typography>


            {course && <form onSubmit={handleSubmit}>

                <Stack spacing={3}>

                    <TextField
                        label="Nom du lieu"
                        value={course.place || ''}
                        onChange={e => setCourse({...course, place: e.target.value})}
                        required
                        size='small'
                        inputProps={{maxLength: 100}}
                    />

                    <Address 
                        value={course}
                        onChange={setCourse}
                        spacing={3}
                    />

                    <LoadingButton
                        variant='contained'
                        type='submit'
                        loading={status === 'submit'}
                    >
                        Enregistrer
                    </LoadingButton>

                </Stack>

            </form>}


            {status === 'loading' && <Loader />}


            {status === 'new' &&
                <Alert severity="warning">
                    Veuillez finaliser la <Link to={`/organize/${id}`}><u>création de l'événement</u> avant de continuer</Link>.
                </Alert>
            }

        </Stack>

    </Layout>
}